<template>
	<div v-if="posters.length > 0" class="posters" style="background-size: contain;background-repeat: no-repeat;">
		<img class="animated  LFfadeIn  -webkit-animation-duration: 2s;" v-for="(item,i) in posters"
			:src="item.swiper_img" v-show="i==bannernum" @click="pushProduct(item.lf_func_lefan_product[0].product)">
		<div class="svgsvg">
			<div class="svgLine" :style="sty"></div>
		</div>
	</div>
</template>

<script>
	let that;
	import SvgIcon from './SvgIcon.vue'
	import request from '../common/request.js'
	import axios from 'axios'

	export default {
		name: 'posters',
		data() {
			return {
				sty: 'animation: tra 1.5s infinite ;',
				bannernum: '1',
				Interval: null,
				imgIndex: 1,
			}
		},
		props: {
			posters: {
				type: Array,
				default() {
					return []
				}
			}
		},
		components: {
			SvgIcon
		},
		mounted() {
			that = this;
			// this.listDate();
			this.play();
			this.partflag = this.$route.query.partname || 'quanshen';
			console.log("globalname", this.activename)
			window.addEventListener('scroll', this.getScroll);
			//初次加载  回到顶部
			let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
			if (scrollTop > 0) {
				document.documentElement.scrollTop = 0;
			}
		},
		destroyed() {
			window.removeEventListener('scroll', this.getScroll);
			this.Interval = null;
		},
		methods: {
			async listDate() {
				// 获取轮播图列表
				request.uniRequest('/swiper/getSwiperList').then(res => {

					this.posters = res.data.filter(item => item.web_type == 1)
					console.log('swiper---------', this.posters);
				}).catch(e => {})
				
			},
			autoplay() {
				let that = this
				that.bannernum++

				if (that.bannernum == that.posters.length) {
					that.bannernum = 0
				}
				if (that.bannernum == 0) {
					this.imgIndex = 2;
				} else {
					this.imgIndex = that.bannernum - 1;
				}

				// console.log("num",this.imgIndex,that.bannernum)
			},
			play() {
				let that = this
				this.Interval = setInterval(function() {
					that.autoplay()
				}, 3500)

			},
			// pushProduct(e) {
			// 	let routeUrl = this.$router.resolve({
			// 		path: "/Productstation",
			// 		query: {
			// 			cpzname: e
			// 		}
			// 	});
			// 	window.open(routeUrl.href, '_self');
			// },
			pushProduct(e){
				console.log('点击商品===>>>>',e)
				let routeUrl = this.$router.resolve({
					path: "/Productstation",
					query: {
						cpzname: e
					}
				});
				window.open(routeUrl.href, '_self');
			},
			getScroll() {
				let that = this;
				let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
				let pageWidth = document.documentElement.clientWidth;

			},
		},

	}
</script>

<style>
	@keyframes LFfadeIn {
		0% {
			opacity: 0
		}

		to {
			opacity: 1
		}
	}

	.LFfadeIn {
		-webkit-animation-name: LFfadeIn;
		animation-name: LFfadeIn
	}

	@keyframes tra {
		0% {
			transform: translateY(2px);
		}

		25% {
			transform: translateY(0px);
		}

		50% {
			transform: translateY(-3px);
		}

		75% {
			transform: translateY(0px);
		}

		100% {
			transform: translateY(2px);
		}
	}

	.posters img {
		width: 100%;
		height: 100%;
		font-size: 0;
	}

	.posters {
		position: relative;
	}

	.svgsvg {
		/* width: 100%; */
		width: 10px;
		height: 20px;
		margin: 0 auto;
		position: absolute;
		left: 0;
		right: 0;
		bottom: 1.875rem;
		/* animation: shake 1s; */
		border: #FFFFFF 1px solid;
		border-radius: 5px;
		align-items: center;
		display: flex;
		justify-content: center;
	}

	.svgLine {
		width: 1px;
		height: 5px;
		background-color: #FFFFFF;
	}
</style>
